import Repository from './Repository';

export default class UserGroupRepository extends Repository {
    protected basePath = 'user-groups';

    protected messages = {
        destroy : this.__('Felhasználó csoport sikeresen törölve.'),
        store : this.__('Felhasználó csoport sikeresen létrehozva.'),
        update : this.__('Felhasználó csoport sikeresen frissítve.'),
    }

    protected redirects = {
        store: { name : 'users.groups' }
    }

    public export(params: object = null): Promise {
        console.error('Export method does not exist on UserGroupRepository.');
    }

    public import(data: object): Promise {
        console.error('Import method does not exist on UserGroupRepository.');
    }
}